import { render, staticRenderFns } from "./EmptyListWidget.vue?vue&type=template&id=46af1b39&scoped=true&"
import script from "./EmptyListWidget.vue?vue&type=script&lang=js&"
export * from "./EmptyListWidget.vue?vue&type=script&lang=js&"
import style0 from "./EmptyListWidget.vue?vue&type=style&index=0&id=46af1b39&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46af1b39",
  null
  
)

export default component.exports